/**
 * Extend Marb namespace with social specific content
 *
 * @author Machi
 */

try {
	Marb.extend({
		Social: {
			/**
			* This dictionary holds a social networks inner representation of a user status per each key in the dictionary
			* being each key the social id (e.g.: 'facebook')
			*/
			currentUser : {},
			/**
			* This queue is intended to hold FB related calls.
			* This way, when you add a function (which contains any FB call) to the queue
			* it will wait for FB to be ready before actually executing. If FB is
			* already loaded, the function will execute right away.
			*
			* Example usage:
			* M.Social.Queue.add(function(){...}, this, arguments);
			* where the first param is the function to be calles, the second is the context,
			* where it is supposed to run and the third one are the arguments to be sent to
			* the given function.
			*/
			Queue : (function() {
				var fbQueue = [];
				var fbReady = false;

				var setFbReady = function(){
					fbReady = true;

					while(fbQueue.length > 0) {
						var c = fbQueue.shift();
						c.f.apply(c.ctx, c.params);
					}
				};

				var add = function(f,ctx,params) {
					if(fbReady) {
						f.apply(ctx, params);
					}
					else {
						fbQueue.push({
							f : f,
							ctx : ctx,
							params : params
						});
					}
				}

				return {
					setFbReady : setFbReady,
					add : add
				};
			})(),
			/**
			* Returns all friends with app in an array of SocialUser objects
			*/
			getFriendsWithApp : function(cb) {
				M.Social.Queue.add(function(){
				FB.api('/me/friends?fields=installed,name,picture', function(response) {
					if(!('error' in response)) {
						var socialIds = [], fullSocialData = [], socialUsers = [];
						for(var i=0, friends=response.data, len=friends.length; i < len; i++) {
							if(friends[i].installed) {
								socialIds.push(friends[i].id);
								fullSocialData.push(friends[i]);
							}
						}

						$.get('/social/toMarbIds', {socialIds : socialIds.join(','), providerId : 'facebook'}).done(function(response) {
							if(response.success) {
								var users = response.data.users;
								
								for(var i=0, len=users.length; i<len; i++) {
									socialUsers.push(new M.SocialUser(users[i]));
								}

								cb(socialUsers);
							}
							else {
								debug.warn('Could not translate to marbIds.', response);
							}
						});
					}
					else {
						debug.warn('Error attempting to get FB friends. Are you logged in FB?',response);
					}
				});
				}, this, arguments);
			},
			/**
			*	Retrieves an array with a dictionary where each key is
			*	one of the marbIds passed in marbIds parameter and its value
			*	is an array of companies ids they've done work with.
			*
			*	For example:
			*		To check which companies users 15 and 18 have worked with,
			*		marbIds = [15,18]
			*		and output (in callback param) would be for instance:
			*		{15: [45,47], 18: []}
			*		meaning that user 15 has finished jobs with companies 45 and 47,
			*		while user 18 has no finished job at all.
			*/
			getWorkedWithCompanies : function(marbIds, cb) {
				if(typeof marbIds == 'string' || typeof marbIds == 'number') {
					marbIds = [marbIds];
				}
				else if(!marbIds) {
					debug.error('Incorrect parameter when calling getWorkedWithCompanies', marbIds);
					return ;
				}

				// call server with ids array, retrieve just company ids they've worked with
				$.get('/social/workedWith', {marbIds : marbIds.join(',')}).done(function(response) {
					if(response.success) {
						cb(response.data.companiesMapping);
					}
					else {
						debug.warn('Could not get "worked with" companies.', response);
					}
				});
			},
			/**
			* Retrieves all social data for the given company or array of companies.
			* This social data is represented by a SocialCompany  object.
			*
			* Returns an object whose key is each company Id and value is the SocialCompany data.
			*/
			getCompanySocialData : function(companyIds, cb) {
				if(typeof companyIds == 'string' || typeof companyIds == 'number') {
					companyIds = [companyIds];
				}
				else if(!companyIds) {
					debug.error('Incorrect parameter when calling getCompanySocialData', companyIds);
					return ;
				}

				$.get('/social/companyData', {companyIds : companyIds.join(',')}).done(function(response) {
					if(response.success) {
						var out = {};
						var sd = response.data.socialData;
						for(var c in sd) {
							if(sd.hasOwnProperty(c)) {
								out[c] = new M.SocialCompany(sd[c]);
							}
						}
						cb(out);
					}
					else {
						debug.warn('Could not get social data for companies.', response);
					}
				});
			},
			/**
			* Gets mutual friends between two social ids. Actually, the second parameter can be
			* an array of social ids. Admits 'me' as the first parameter.
			* Returns an object where each key is a socialId from second param, and its value is
			* an array of SocialUser objects (these being the mutual friends per se)
			*/
			getMutualFriends : function(socialIdA, socialIdsB, cb) {
				M.Social.Queue.add(function(){
				if(typeof socialIdsB == 'string') {
					socialIdsB = [socialIdsB];
				}
				else if(!socialIdsB) {
					debug.error('Incorrect parameter when calling getMutualFriends', socialIdsB);
					return ;
				}

				var mutualfriends = {};
				var doGetMutualFriends = function(socialIdA, socialIdsB) {
					if(socialIdsB.length > 0) {
						var socialIdB = socialIdsB.shift();
						// In case we receive duplicate socialIdB, continue
						if(socialIdB in mutualfriends) {
							doGetMutualFriends(socialIdA, socialIdsB);
							return ;
						}
						FB.api(
							"/"+socialIdA+"/mutualfriends/"+socialIdB+"?fields=name,picture",
							function (response) {
								if (response && !response.error) {
									var socialUsers = [];
									for(var i=0, friends=response.data, len=friends.length; i < len; i++) {
										socialUsers.push(new M.SocialUser({
											socialId : friends[i].id,
											displayName : friends[i].name,
											imageUrl : friends[i].picture.data.url
										}));
									}
									mutualfriends[socialIdB] = socialUsers;
									doGetMutualFriends(socialIdA, socialIdsB);
								}
								else {
									debug.warn('Error attempting to get FB mutual friends.',response);
								}
							}
						);
					}
					else {
						cb(mutualfriends);
					}
				}

				doGetMutualFriends(socialIdA, socialIdsB);
				}, this, arguments);
			},
			Analysis : {
				CompanyListing : (function(){
					var currentStep;
					var currentSocialCompany;
					var output = {
						reviewerFriends : [],
						mutualFriendsWithCompany : [],
						mutualFriendsWithReviewers : []
					};
					var socialCompanies = [];
					var renderCallback;
					// We'll use this dictionary to flag already included social ids.
					// This way we prevent duplicating a social edge (for instance, a 
					// user could be at the same time mutual friend with pro and a reviewer or friend
					// of a reviewer)
					var flagged = {};
					var init = function(params) {
						M.Social.Queue.add(function(){
						if(!params || !params.companyIds) {
							debug.error('Incorrect parameter to initialize social analysis');
							return ;
						}
						// If true, once we get data for item -1- or -2- or -3-, stop analysis for current company
						priorityTargets = params.priorityTargets || false;
						renderCallback = params.renderCallback;

						debug.debug('Beginning social analysis...');
						M.Social.getCompanySocialData(params.companyIds, function(response){
							// Some heavy processing, per company. We want to find out:
							// 	1- Friends with finished jobs with this company
							//	2- Friends in common with the pro itself
							//	3- Friends in common with companies customers (with finished jobs)
							for(var companyId in response) {
								if(response.hasOwnProperty( companyId )) {
									socialCompanies.push(response[companyId]);
								}
							}
							debug.debug('Gathered companies social data: ', socialCompanies);
							analyse();
						});
						}, this, arguments);
					};
					var analyse = function() {
						if(socialCompanies.length > 0) {
							flagged = {};
							currentStep = 0;
							output.reviewerFriends = [];
							output.mutualFriendsWithCompany = [];
							output.mutualFriendsWithReviewers = [];
							currentSocialCompany = socialCompanies.shift();
							if(!(currentSocialCompany instanceof M.SocialCompany)) {
								debug.warn('Not a SocialCompany object', currentSocialCompany);
								analyse(); // continue analysis with next company
							}
							else {
								doNextStep();
							}
						}
						else {
							debug.debug('No more socialCompanies to analyse.');
						}
					};
					var doNextStep = function() {
						if(currentStep == funcs.length) {
							render(currentSocialCompany.companyId, output);
						}
						else {
							funcs[currentStep++]();
						}
					};
					var skipRemainingAnalysis = function() {
						debug.debug('We already have some social data, skip rest of analysis');
						render(currentSocialCompany.companyId, output);
					};
					var funcs = [
			 			//-1-
						function() {
							debug.debug('1- Friends with finished jobs with this company (' + currentSocialCompany.companyId + ')');
							M.Social.getFriendsWithApp(function(myFriendsWithApp) {
								for(var i=0, len_i=myFriendsWithApp.length; i<len_i; i++) {
									// look for every friendwithapp of mine in the list of company customers
									for(var j=0, customers=currentSocialCompany.customers, len_j=customers.length; j<len_j; j++) {
										if(myFriendsWithApp[i].equals(customers[j]) && !flagged[customers[j].socialId]) {
											flagged[customers[j].socialId] = true;
											output.reviewerFriends = output.reviewerFriends.concat(customers.splice(j,1));
											break;
										}
									}
								}
								debug.debug('reviewerFriends:', output.reviewerFriends);
								if(priorityTargets && output.reviewerFriends.length > 0) {
									skipRemainingAnalysis();
								}
								else {
									doNextStep();
								}
							});
						},
						// -2-
						function() {
							debug.debug('2- Friends in common with the pro itself');
							if('facebook' in currentSocialCompany.owner.social) {
								var companyOwnerSocialId = currentSocialCompany.owner.social['facebook'].socialId;
								M.Social.getMutualFriends('me', companyOwnerSocialId, function(mutualWithCompany){
									var socialUsers = mutualWithCompany[companyOwnerSocialId];
									for (var i = 0; i < socialUsers.length; i++) {
										var sid = socialUsers[i].socialId;
										if(!flagged[sid]) {
											flagged[sid] = true;
											output.mutualFriendsWithCompany.push(socialUsers[i]);
										}
									};
									debug.debug('mutualFriendsWithCompany:', output.mutualFriendsWithCompany);
									if(priorityTargets && output.mutualFriendsWithCompany.length > 0) {
										skipRemainingAnalysis();
									}
									else {
										doNextStep();
									}
								});
							}
							else {
								debug.debug('No social data for company owner, so no mutualFriendsWithCompany');
								doNextStep();
							}
						},
						// -3-
						function() {
							debug.debug('3- Friends in common with companies customers (with finished jobs)');
							var socialIds = [];
							var mySocialId = M.Social.currentUser.facebook.authResponse.userID;
							for(var i=0, customers=currentSocialCompany.customers, len=customers.length; i<len; i++) {
								if(customers[i].socialId != mySocialId) {
									socialIds.push(customers[i].socialId);
								}
							}
							M.Social.getMutualFriends('me', socialIds, function(mutualWithReviewers) {
								for (var key in mutualWithReviewers) {
									var socialUsers = mutualWithReviewers[key];
									for (var j = 0; j < socialUsers.length; j++) {
										var sid = socialUsers[j].socialId;
										if(!flagged[sid]) {
											flagged[sid] = true;
											output.mutualFriendsWithReviewers.push(socialUsers[j]);
										}
									};
								}
								debug.debug('mutualFriendsWithReviewers:', output.mutualFriendsWithReviewers);
								if(priorityTargets && output.mutualFriendsWithReviewers.length > 0) {
									skipRemainingAnalysis();
								}
								else {
									doNextStep();
								}
							});
						}
					];
					var render = function(companyId, data) {
						// It's very important to clone the "data" param
						// because it will be modified in subsequent calls
						var dataCloned = {
							reviewerFriends : data.reviewerFriends,
							mutualFriendsWithCompany : data.mutualFriendsWithCompany,
							mutualFriendsWithReviewers : data.mutualFriendsWithReviewers
						};
						debug.debug('>>> Rendering social data for company with id ' + companyId, dataCloned);
						if(!renderCallback) {
							debug.warn('No renderCallback provided');
						}
						else {
							renderCallback({
								companyId : companyId, 
								data : dataCloned
							});
						}
						debug.debug('Let\'s analyse the next company');
						analyse();
					}
					
					return {
						init : init
					};
				})()
			}
		}
	});
}
catch (e) {
	debug.error("Marb namespace not present", e);
}
